import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import {
    deleteCommercial,
    editCommercial,
    editCommercialPro,
    getCommercial,
    getCommercialList,
    updateCommercial,
} from '../sellThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
const SLICE_NAME = 'sellCommercial';

export const sellCommercialSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getCommercialList });
        handleRequestThunk({ builder, request: getCommercial });
        handleRequestThunk({
            builder,
            request: deleteCommercial,
            isDelete: true,
        });
        handleRequestThunk({ builder, request: editCommercial });
        handleRequestThunk({ builder, request: editCommercialPro });
        handleRequestThunk({ builder, request: updateCommercial });
    },
});

export const sellCommercial = sellCommercialSlice.reducer;
